import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import CalculateIcon from "@mui/icons-material/Calculate";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";

const modeButtonSx = {
  flex: 1,
  minHeight: 132,
  p: 2,
  borderRadius: 2,
  alignItems: "flex-start",
  justifyContent: "flex-start",
  textAlign: "left",
  textTransform: "none",
  borderWidth: 1.5,
  "&:hover": { borderWidth: 1.5 },
};

const MbsModeDialog = ({ open, onClose, onSelect, currentMode }) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
    <DialogTitle
      sx={{
        bgcolor: "primary.main",
        color: "primary.contrastText",
        fontWeight: 700,
      }}
    >
      Select MBS Mode
    </DialogTitle>
    <DialogContent dividers sx={{ pt: 2.5 }}>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Choose how Monthly Basic Salary will be calculated for this report.
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          gap: 2,
        }}
      >
        <Button
          variant="outlined"
          color="primary"
          onClick={() => onSelect("normal")}
          startIcon={<CalculateIcon />}
          sx={{
            ...modeButtonSx,
            bgcolor: currentMode === "normal" ? "action.selected" : "background.paper",
          }}
        >
          <Box>
            <Typography variant="subtitle1" fontWeight={700}>
              Normal MBS
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Daily Rate × 313 ÷ 12
            </Typography>
          </Box>
        </Button>
        <Button
          variant="outlined"
          color="secondary"
          onClick={() => onSelect("phil")}
          startIcon={<LocalHospitalIcon />}
          sx={{
            ...modeButtonSx,
            bgcolor: currentMode === "phil" ? "action.selected" : "background.paper",
          }}
        >
          <Box>
            <Typography variant="subtitle1" fontWeight={700}>
              PHIL MBS
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Reconstruct daily rate from PH Total (EE)
            </Typography>
          </Box>
        </Button>
      </Box>
      <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 2 }}>
        PHIL MBS restores the implied whole-peso daily rate, then applies Daily Rate × 313 ÷ 12.
      </Typography>
    </DialogContent>
    <DialogActions sx={{ px: 3, py: 1.5 }}>
      <Button onClick={onClose}>Cancel</Button>
    </DialogActions>
  </Dialog>
);

export default MbsModeDialog;
